import { render, staticRenderFns } from "./CModalBody.vue?vue&type=template&id=e240800a&"
import script from "./CModalBody.vue?vue&type=script&lang=js&"
export * from "./CModalBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports